// extracted by mini-css-extract-plugin
module.exports = {"singleImageWrap":"single-image-warp_singleImageWrap___Gr9Z"};